// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_core-app_module_ts":"c8289690753eb78f","src_app_home_home_module_ts":"115dc9a34baad50d"}[chunkId] + ".js";
};